import React, { useState, useEffect, useContext } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'syngenta-react-components'
import clear from '../../assets/icons/clear.svg'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import { postNewRole } from '../../services/apiHelper'
import { GlobalContext } from '../../services/context'

const NewRoleForm = ({ handleClose, handleDataRefresh, permisisonsData }) => {
  const { trackEvent } = useContext(GlobalContext)
  const [options, setOptions] = useState([])
  const [selectedPermissions, setSelectedPermissions] = useState()
  const [selectedRoleType, setSelectedRoleType] = useState()
  const [submissionStatus, setSubmissionStatus] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const { register, errors, clearError, handleSubmit, reset } = useForm()

  useEffect(() => {
    permisisonsData.forEach(perm => {
      const data = perm.permissionsData.map(permission => {
        return {
          permission_name: permission.display_name,
          permission_code: permission.permission,
          role_id: permission.role_id,
          isChecked: false
        }
      })
      setOptions(data)
    })
  }, [setOptions, handleDataRefresh, permisisonsData])

  useEffect(() => {
    const updatedArray = options.map(
      option => option.isChecked && option.permission_code
    )
    setSelectedPermissions(updatedArray)
  }, [options])

  const onSubmit = formValues => {
    setSubmissionStatus('LOADING')
    let display_name = formValues.new_role_name
    let description = formValues.new_role_description
    let permissions = selectedPermissions.filter(function (permission_code) {
      return permission_code !== false
    })
    let role_type = selectedRoleType
    trackEvent('create_role_clicked', {
      displayName: display_name,
      description,
      permissions
    })
    postNewRole({ role_type, display_name, description, permissions }).then(
      res => {
        if (res?.status === 200) {
          setSubmissionStatus('SUCCESS')
          handleDataRefresh()
        } else {
          let errorMessage =
            (res?.data?.errors && res?.data?.errors[0]?.message) || ''
          setErrorMessage(errorMessage)
          setSubmissionStatus('FAILED')
        }
      }
    )
    reset()
    clearError()
  }

  const handleCancelModal = () => {
    reset()
    clearError()
    setSubmissionStatus()
    setErrorMessage()
    handleClose()
    setSelectedPermissions(null)
  }

  const roleTypeSelection = value => {
    setSelectedRoleType(value)
  }

  let content = (
    <>
      <div className="df jcsb">
        <p className="fz16 ml16 fw600">Create new role</p>
        <button className="bdnone m0 bgc-t" onClick={handleCancelModal}>
          <img src={clear} alt="cancel button" />
        </button>
      </div>
      <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
      <div className="w100% pr16 df jcsb tal fxdrr fz15">
        <div className="w100% mb15">
          <input
            type="radio"
            id="admin"
            name="role_type"
            value="admin"
            onChange={() => roleTypeSelection('admin')}
            className="pt5 ml15 tac w5%"
          />
          <label htmlFor="admin">Admin</label>

          <input
            type="radio"
            id="external"
            name="role_type"
            value="external"
            onChange={() => roleTypeSelection('external')}
            className="pt5 ml15 tac w5%"
          />
          <label htmlFor="external">External</label>

          <input
            type="radio"
            id="internal"
            name="role_type"
            value="internal"
            onChange={() => roleTypeSelection('internal')}
            className="pt5 ml15 tac w5%"
          />
          <label htmlFor="internal">Internal</label>
        </div>
        <div className="c-red tal fz13 mt5">
          {errors.radio_button &&
            errors.radio_button.type === 'required' &&
            'New role name is required. Please complete this field'}
        </div>
      </div>
      <div className="hfit w100% pl16 pr16 df jcsb fxdrr fxww">
        <div className="tal w100%">
          <form className="df fxdrr jcsb" onSubmit={handleSubmit(onSubmit)}>
            <div className="tal w45%">
              <label className="fz13">New role name</label>
              <div className="fz10">(For example: Internal)</div>
              <input
                className="bd1-s-lightgray mt4 lh1.5 fz15"
                type="text"
                name="new_role_name"
                ref={register({ required: true })}
              />
              <div className="c-red tal fz13 mt5">
                {errors.new_role_name &&
                  errors.new_role_name.type === 'required' &&
                  'New role name is required. Please complete this field'}
              </div>
            </div>
            <div className="w45% mr10">
              <label className="fz13">New role description</label>
              <div className="fz10">(For example: Internal Syngenta user)</div>
              <input
                className="bd1-s-lightgray mt4 lh1.5 fz15"
                type="text"
                name="new_role_description"
                ref={register({ required: true })}
              />
              <div className="c-red tal fz13 mt5">
                {errors.new_role_description &&
                  errors.new_role_description.type === 'required' &&
                  'Description of the new role is required. Please complete this field'}
              </div>
            </div>
          </form>
        </div>
        <div className="w100% bd1-s-lightgray bdrs-4 mt20">
          <div className="tal mt20 mb20">
            {options.map(d => {
              return (
                <div key={d.permission_code} className="df fxdrr tal mb10">
                  <label className="w100% tal fz15">
                    <input
                      className="w10% checkbox"
                      onChange={event => {
                        let isChecked = event.target.checked
                        setOptions(
                          options.map(data => {
                            if (d.permission_code === data.permission_code) {
                              data.isChecked = isChecked
                            }
                            return data
                          })
                        )
                      }}
                      type="checkbox"
                      checked={d.isChecked}
                    ></input>
                    {d.permission_name}
                  </label>
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <hr className="mt20 mb16 bdnone bt1-s-lightgray" />
      <div className="df jcfe">
        <Button
          text="Cancel"
          customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          clickHandler={handleCancelModal}
        >
          Cancel
        </Button>
        <div data-testid="createRoleButton">
          <Button
            type="success"
            text="Create role"
            clickHandler={handleSubmit(onSubmit)}
            customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
          />
        </div>
      </div>
    </>
  )

  switch (submissionStatus) {
    case 'SUCCESS':
      content = (
        <div>
          <div className="df jcsb">
            <p className="fz16 ml20 fw600">New role</p>
          </div>
          <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
          <p>New role successfully created</p>
          <div className="df jcfe mr25 mt20">
            <Button styleType="success" onClick={handleCancelModal}>
              Close
            </Button>
          </div>
        </div>
      )
      break
    case 'FAILED':
      content = (
        <div>
          <div className="df jcsb">
            <p className="fz16 ml20 fw600">New role</p>
          </div>
          <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
          <p>Failed to create new role</p>
          {errorMessage}
          <div className="df jcfe mr25 mt20">
            <Button styleType="success" onClick={handleCancelModal}>
              Close
            </Button>
          </div>
        </div>
      )
      break
    case 'LOADING':
      content = (
        <div>
          <div className="df jcsb">
            <p className="fz16 ml20 fw600">New role</p>
          </div>
          <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
          <div className="mt40 mb20">Creating new role, please wait...</div>
          <TableStatus status={'LOADING'} />
        </div>
      )
      break
    default:
      break
  }

  return (
    <div className="w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40">
      {content}
    </div>
  )
}

export default NewRoleForm
